import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useJWTAuth } from "../context/JWTAuthContext";

const AdminRoute = () => {
  const { isAuthenticated, getUserRole, loading } = useJWTAuth();

  // Показываем индикатор загрузки, пока проверяем аутентификацию
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[var(--color-primary)]"></div>
      </div>
    );
  }

  // Проверяем, аутентифицирован ли пользователь и имеет ли он права администратора
  const userRole = getUserRole();
  const isAdmin = ["admin", "superadmin", "megaadmin", "assistant"].includes(userRole?.toLowerCase?.());

  if (!isAuthenticated) {
    // Если пользователь не аутентифицирован, перенаправляем на страницу входа
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    // Если пользователь аутентифицирован, но не является администратором, перенаправляем на главную
    return <Navigate to="/dashboard" replace />;
  }

  // Если все проверки пройдены, рендерим дочерние роуты
  return <Outlet />;
};

export default AdminRoute;
